import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

export const useBackGestureHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // SPA history stack update - ASLA login, register veya public sayfaları oturum içi geçmişe ekleme
    const currentPath = location.pathname;
    const isAuthOrPublic = currentPath === '/login' || currentPath === '/register' || currentPath === '/forgot-password' || currentPath === '/';
    
    if (!isAuthOrPublic) {
      let spaHistory = JSON.parse(sessionStorage.getItem('spa_history') || '[]');
      if (spaHistory[spaHistory.length - 1] !== currentPath) {
        spaHistory.push(currentPath);
        if (spaHistory.length > 20) spaHistory.shift();
        sessionStorage.setItem('spa_history', JSON.stringify(spaHistory));
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    // Güvenli ana sayfa belirleyici (Geri gelindiğinde login yerine güvenli dashboard)
    const getSafeFallback = () => {
      try {
        const selectedBusiness = JSON.parse(localStorage.getItem('selectedBusiness') || 'null');
        if (selectedBusiness) {
          const sector = (selectedBusiness.sector || selectedBusiness.category || '').toLowerCase();
          if (sector.includes('food') || sector.includes('restaurant')) {
            return '/sectors/food-beverage/dashboard';
          } else if (sector.includes('service') || sector.includes('hospitality')) {
            return '/sectors/service/hospitality/dashboard';
          } else if (sector.includes('retail')) {
            return '/sectors/retail/dashboard';
          }
        }
      } catch (e) {}
      return '/sectors/food-beverage/dashboard';
    };

    if (Capacitor.isNativePlatform()) {
      // 📱 Native Platform (Android/iOS) Geri Tuşu ve El Hareketi Yönetimi
      let backListenerPromise = null;

      const setupNativeBack = async () => {
        try {
          const { App } = await import('@capacitor/app');
          
          backListenerPromise = App.addListener('backButton', ({ canGoBack }) => {
            const currentPath = window.location.pathname;
            let spaHistory = JSON.parse(sessionStorage.getItem('spa_history') || '[]');
            
            // Login/public sayfaları filtrele
            spaHistory = spaHistory.filter(p => p && p !== '/login' && p !== '/register' && p !== '/');
            
            if (spaHistory.length >= 2) {
              spaHistory.pop(); // current
              const prevPage = spaHistory.pop(); // previous
              sessionStorage.setItem('spa_history', JSON.stringify(spaHistory));
              
              if (prevPage && prevPage !== currentPath && prevPage !== '/login') {
                navigate(prevPage, { replace: true });
                return;
              }
            }
            
            const fallback = getSafeFallback();
            if (currentPath === fallback || currentPath === '/dashboard' || currentPath === '/') {
              App.exitApp();
            } else {
              navigate(fallback, { replace: true });
            }
          });
        } catch (err) {
          console.warn('⚠️ Capacitor App plugin dynamically import failed:', err);
        }
      };

      setupNativeBack();

      return () => {
        if (backListenerPromise) {
          backListenerPromise.then(listener => listener.remove().catch(() => {}));
        }
      };
    } else {
      // 🌐 Web Tarayıcı Geri Tuşu Yönetimi (Mevcut PopState Guard Yapısı)
      window.history.pushState({ isGestureGuard: true }, '', window.location.href);

      const handlePopState = (event) => {
        const state = event.state;
        if (!state || !state.isGestureGuard) {
          let spaHistory = JSON.parse(sessionStorage.getItem('spa_history') || '[]');
          // Asla login veya ana sayfaya geri atmaması için filtrele
          spaHistory = spaHistory.filter(p => p && p !== '/login' && p !== '/register' && p !== '/');
          
          if (spaHistory.length >= 2) {
            spaHistory.pop(); // current
            const prevPage = spaHistory.pop(); // previous
            sessionStorage.setItem('spa_history', JSON.stringify(spaHistory));
            
            if (prevPage && prevPage !== location.pathname && prevPage !== '/login') {
              navigate(prevPage, { replace: true });
              window.history.pushState({ isGestureGuard: true }, '', window.location.href);
              return;
            }
          }

          const fallback = getSafeFallback();
          // Kullanıcı zaten fallback sayfasındaysa zorla login'e gitmesini engelle
          if (location.pathname !== fallback) {
            navigate(fallback, { replace: true });
          }
          window.history.pushState({ isGestureGuard: true }, '', window.location.href);
        }
      };

      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [location.pathname, navigate]);

};
